import BigNumber from 'bignumber.js'
import masterchefABI from 'config/abi/masterchef.json'
import erc20ABI from 'config/abi/erc20.json'
import multicall from 'utils/multicall'
import contracts from "../../config/constants/contracts";
import {getAddress, getMasterChefAddress} from "../../utils/addressHelpers";




export const fetchBusdBalance = async (account: string) => {

  const stablesArray = [
    getAddress(contracts.busd),
    // getAddress(contracts.usdc),
    // getAddress(contracts.usdt),
    // getAddress(contracts.dai),
  ]

  const calls = stablesArray.map((x) => {
    const lpContractAddress = x
    return {
      address: lpContractAddress,
      name: 'balanceOf',
      params: [account],
    }
  })

  const rawTokenBalances = await multicall(erc20ABI, calls)
  const parsedTokenBalances = rawTokenBalances.map((tokenBalance) => {
    return new BigNumber(tokenBalance.balance._hex).toJSON()
  })
  return parsedTokenBalances
}

export const fetchStablesAllowance = async (account: string) => {
  const masterChefAdress = getMasterChefAddress()

  const stablesArray = [
    getAddress(contracts.busd),
    // getAddress(contracts.usdc),
    // getAddress(contracts.usdt),
    // getAddress(contracts.dai),
  ]

  const calls = stablesArray.map((x) => {
    const lpContractAddress = x
    return {
      address: lpContractAddress,
      name: 'allowance',
      params: [account, masterChefAdress],
    }
  })

  const rawLpAllowances = await multicall(erc20ABI, calls)
  const parsedLpAllowances = rawLpAllowances.map((lpBalance) => {
    return new BigNumber(lpBalance).toJSON()
  })
  return parsedLpAllowances
}

export const fetchUserDeposit = async (account: string) => {
  const masterChefAdress = getMasterChefAddress()
  const BUSD = ['x']

  const calls = BUSD.map((xxx) => {
    return {
      address: masterChefAdress,
      name: 'balance',
      params: [account],
    }
  })

  const rawBalance = await multicall(masterchefABI, calls)
  const parsedBalance = rawBalance.map((lpBalance) => {
    return new BigNumber(lpBalance).toJSON()
  })
  return parsedBalance
}


export const fetchAllPoolsInfo = async () => {
  const masterChefAdress = getMasterChefAddress()
  const pools = new Array(120).fill(0)
  const calls = pools.map((xxx, id) => {

    return {
      address: masterChefAdress,
      name: 'poolInfo',
      params: [id],
    }
  })

  const rawBalance = await multicall(masterchefABI, calls)
  const parsedBalance = rawBalance.map((lpBalance) => {
    return new BigNumber(lpBalance.pancakePID._hex).toJSON()
  })
  return parsedBalance
}

